import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import adicionarFiltroUsuario from '../../../actions/usuario/adicionarFiltroUsuario'
import removerFiltroUsuario from '../../../actions/usuario/removerFiltroUsuario'
import listarFiltrosUsuario from '../../../actions/usuario/listarFiltrosUsuario'
import {
    FILTRO_CPF,
    FILTRO_DATA_CRIACAO,
    FILTRO_EMAIL_USUARIO,
    FILTRO_NOME_USUARIO,
    FILTRO_PLATAFORMA,
    FILTRO_STATUS_USUARIO
} from '../../../util/filtros'
import FiltroBuscaUsuariosPlataformas from './FiltroBuscaUsuariosPlataformas';
import FiltroBuscaUsuario from '../empresa/FiltroBuscaUsuario';
import Autorizacao from '../../../security/Autorizacao';
import {PERFIL_ADMIN} from '../../../security/securityContext';

export class FiltroUsuariosPlataformas extends Component {

    adicionarFiltro(filtro) {
        this.props.adicionarFiltroUsuario(filtro)
    }

    removerFiltro(filtro) {
        this.props.removerFiltroUsuario(filtro)
    }

    render() {
        return (
            <React.Fragment>
                <div className="conteudo">
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                        <FiltroBuscaUsuariosPlataformas
                            filtro={FILTRO_DATA_CRIACAO}
                            opcoes={[new Date().getFullYear()]}
                            isFiltroData={true}
                        />
                    </Autorizacao>
                    <FiltroBuscaUsuariosPlataformas
                        filtro={FILTRO_CPF}
                        isCpf={true}
                    />
                    <FiltroBuscaUsuariosPlataformas
                        filtro={FILTRO_NOME_USUARIO}
                        isNome={true}
                        opcoes={[]}
                    />
                    <FiltroBuscaUsuariosPlataformas
                        filtro={FILTRO_EMAIL_USUARIO}
                        isEmail={true}
                        opcoes={[]}
                    />
                    <FiltroBuscaUsuariosPlataformas
                        filtro={FILTRO_STATUS_USUARIO}
                        opcoes={['Ativo', 'Inativo']}
                        isRadio={true}
                    />
                    <FiltroBuscaUsuario
                        filtro={FILTRO_PLATAFORMA}
                        opcoes={this.props.plataformas.filter(it => it != 'Todas')}
                    />
                </div>
            </React.Fragment>
        )
    }
}

export function mapStateToProps(state) {
    return {
        plataformas: state.plataformas
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        adicionarFiltroUsuario,
        removerFiltroUsuario,
        listarFiltrosUsuario
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(FiltroUsuariosPlataformas)
